<script setup lang="ts">
import NoDataContent from '@/common/components/molecules/noData/NoDataContent.vue';
import IconDecoLine from '@/common/components/molecules/iconDecoLine/IconDecoLine.vue';

import { useInternational } from '@/common/locale';

const { t } = useInternational();
</script>

<template>
  <div class="menu-search-no-result">
    <no-data-content>
      <template #icon>
        <icon-deco-line>
          <ev-icon icon="icon-search" />
        </icon-deco-line>
      </template>
      <template #message>
        {{ t('MESSAGE.GNB_SEARCH_NO_RESULT_MESSAGE') }}
      </template>
    </no-data-content>
  </div>
</template>

<style scoped lang="scss">
.menu-search-no-result {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  :deep(.no-data-content__message) {
    color: var(--color-gray-02-10);
  }
}
</style>
